import { patchExperiment } from '@gonfalon/openapi/operations/patchExperiment';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createMutationHook } from '../internal/createMutationHook';
import { experimentDetail, getExperimentQuery, getExperimentsQuery } from '../queries/experiments';

type UpdateExperimentOptions = {
  shouldInvalidateQueries?: boolean;
};

export const useUpdateExperiment = (options: UpdateExperimentOptions = {}) => {
  const { shouldInvalidateQueries = true } = options;

  return createMutationHook(patchExperiment, {
    onSuccess: async (_, { projectKey, environmentKey, experimentKey }) => {
      if (!shouldInvalidateQueries) {
        return;
      }

      const queryClient = getQueryClient();
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: getExperimentQuery.partialQueryKey({
            projectKey,
            environmentKey,
            experimentKey,
          }),
        }),
        queryClient.invalidateQueries(experimentDetail({ projectKey, environmentKey, experimentKey })),
        queryClient.invalidateQueries({
          queryKey: getExperimentsQuery.partialQueryKey({
            projectKey,
            environmentKey,
          }),
        }),
      ]);
    },
  })();
};
